import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components'

import { KioskConfiguration, KioskStyleConfiguration } from './type';
import { fetchJsonFromUrl } from '../../utils/request';
import { Loader } from '../../components/loader/Loader';


interface Context {
  kioskConfiguration: KioskConfiguration
  isKioskConfigurationLoading: boolean
}

export const KioskConfigurationContext = createContext<Context | null>(null)

type Props = {
  children: React.ReactElement,
}

export const KioskConfigurationProvider = (props: Props): React.ReactElement => {
  // const location = useLocation()
  const [kioskConfiguration, setKioskConfiguration] = useState<KioskConfiguration | null>(null)
  const [isKioskConfigurationLoading, setLoading] = useState<boolean>(true)
  const [hasLoadingError, setLoadingError] = useState<boolean>(false)

  const loadKioskConfiguration = async () => {
    try {
      const data = await fetchJsonFromUrl<KioskConfiguration>(`${process.env.APP_DATA_LINK}/config.json`)
      setKioskConfiguration(data)
      setLoading(false)
    } catch (e) {
      setLoadingError(true)
    }
  }

  useEffect(() => {
    if (location.pathname !== '/') {
      window.location.href = '/';
    } else {
      loadKioskConfiguration()
    }
  }, []);

  if (hasLoadingError) {
    return <h1>Config error</h1>
  }

  if (isKioskConfigurationLoading || kioskConfiguration === null) {
    return <Loader />
  }

  const providerValue = {
    kioskConfiguration,
    isKioskConfigurationLoading,
  }

  const KioskconfigurationStyle = styled.div<{ styleConfig: KioskStyleConfiguration }>`
    .header {
        background-color: ${(props) => props.styleConfig.headerBackgroundColor};
    }
      
    .notification-error {
        background-color: ${(props) => props.styleConfig.alertErrorBackgroundColor};
        color: ${(props) => props.styleConfig.alertErrorTextColor};
    }

    .notification-error svg {
        fill: ${(props) => props.styleConfig.alertErrorIconColor};
    }

    .notification-success {
        background-color: ${(props) => props.styleConfig.alertSuccessBackgroundColor};
        color: ${(props) => props.styleConfig.alertSuccessTextColor};
    }
      
    .notification-success svg {
        fill: ${(props) => props.styleConfig.alertSuccessIconColor};
    }

    .rt-Button {
        cursor: pointer;
        border-radius: 0;
    }

    .rt-Button:disabled, .rt-Button[disabled] {
        cursor: not-allowed;
        opacity: 0.7;
    }

    .rt-variant-solid {
        background-color: ${(props) => props.styleConfig.primaryButtonBackgroundColor};
        color: ${(props) => props.styleConfig.primaryButtonTextColor};
    }
    .rt-variant-surface {
        box-shadow: inset 0 0 0 1px ${(props) => props.styleConfig.secondaryButtonBackgroundColor}; 
        color: ${(props) => props.styleConfig.secondaryButtonTextColor};
    }

    .switch input:checked + .slider {
        background-color: ${(props) => props.styleConfig.headerBackgroundColor};
    }

    .switch input:focus + .slider {
        box-shadow: 0 0 1px ${(props) => props.styleConfig.headerBackgroundColor};
    }
  `;

  return (
    <KioskConfigurationContext.Provider value={providerValue}>
      <KioskconfigurationStyle styleConfig={kioskConfiguration.style} className="h-full">
        {props.children}
      </KioskconfigurationStyle>
    </KioskConfigurationContext.Provider>

  );
}

export const useKioskConfiguration = (): Context => {
  const context = useContext(KioskConfigurationContext);

  if (!context) {
    throw new Error('usePage must be used within a KioskConfigurationProvider');
  }

  return context;
};

